var React = require('react');

function IconCancelO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M511.3 65.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z","key":0}),React.createElement("path",{"d":"M315.7 665.3L661.1 320c3.9-3.9 10.2-3.9 14.1 0l32.2 32.2c3.9 3.9 3.9 10.2 0 14.1L362 711.7c-3.9 3.9-10.2 3.9-14.1 0l-32.2-32.2c-3.9-3.9-3.9-10.3 0-14.2z","key":1})]);
}

IconCancelO.displayName = "IconCancelO";

IconCancelO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCancelO;

IconCancelO.default = IconCancelO;
